// Elementi comuni delle pagine Anagrafiche
export const TIPI_SOGGETTO = { societa_capitali: 'Società di capitali', societa_persone: 'Società di persone', ditta_individuale: 'Ditta individuale', persona_fisica: 'Persona fisica', altro: 'Altro' };

export function quando(iso) {
  return iso ? new Date(iso).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '';
}

export async function scaricaFile(api, url, params, nomeFile) {
  const res = await api.get(url, { params, responseType: 'blob' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(res.data);
  link.download = nomeFile;
  link.click();
  setTimeout(() => URL.revokeObjectURL(link.href), 1000);
}

export const badge = {
  daCompletare: { fontSize: '0.72rem', background: '#fff7ed', color: '#9a3412', border: '1px solid #fdba74', padding: '0.08rem 0.45rem', borderRadius: '999px', whiteSpace: 'nowrap', fontWeight: 600 },
  archiviata: { fontSize: '0.72rem', background: '#f1f1ee', color: '#5a5a56', border: '1px solid #d6d6d0', padding: '0.08rem 0.45rem', borderRadius: '999px', whiteSpace: 'nowrap', fontWeight: 600 },
  completa: { fontSize: '0.72rem', background: '#ecfdf5', color: '#166534', border: '1px solid #86efac', padding: '0.08rem 0.45rem', borderRadius: '999px', whiteSpace: 'nowrap' },
};
